module.exports = __webpack_public_path__ + "static/media/home-architect-image-04.8cea3384.jpg";